import React from 'react';
import { Lead } from '../../types/lead';
import { UploadCloud, FileText } from 'lucide-react';
interface LeadFieldsPanelProps {
  lead: Lead;
  onChange: (field: keyof Lead, value: any) => void;
}
export function LeadFieldsPanel({
  lead,
  onChange
}: LeadFieldsPanelProps) {
  return <div className="space-y-6" data-id="element-314">
      <div className="card p-5" data-id="element-315">
        <h3 className="text-[14px] font-semibold text-growthly-text mb-4 border-b border-white/5 pb-2" data-id="element-316">
          Estado Digital del Negocio
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4" data-id="element-317">
          <div data-id="element-318">
            <label className="block text-[12px] font-medium text-growthly-muted mb-1" data-id="element-319">
              Estado Web
            </label>
            <select value={lead.ESTADO_WEB_MENU} onChange={e => onChange('ESTADO_WEB_MENU', e.target.value)} className="input-field" data-id="element-320">
              <option value="No web" data-id="element-321">No web</option>
              <option value="Web obsoleta" data-id="element-322">Web obsoleta</option>
              <option value="Web funcional" data-id="element-323">Web funcional</option>
            </select>
          </div>
          <div data-id="element-324">
            <label className="block text-[12px] font-medium text-growthly-muted mb-1" data-id="element-325">
              Estado Menú
            </label>
            <select value={lead.MENU_STATUS} onChange={e => onChange('MENU_STATUS', e.target.value)} className="input-field" data-id="element-326">
              <option value="Papel" data-id="element-327">Papel</option>
              <option value="PDF" data-id="element-328">PDF</option>
              <option value="Digital" data-id="element-329">Digital</option>
            </select>
          </div>
        </div>

        <div data-id="element-330">
          <label className="block text-[12px] font-medium text-growthly-muted mb-1" data-id="element-331">
            Nota de Carencia (Identificación de necesidad)
          </label>
          <input type="text" value={lead.NOTA_CARENCIA || ''} onChange={e => onChange('NOTA_CARENCIA', e.target.value)} placeholder="Ej: Menú sucio, web no carga en móvil..." className="input-field" data-id="element-332" />
        </div>
      </div>

      <div className="card p-5" data-id="element-333">
        <h3 className="text-[14px] font-semibold text-growthly-text mb-4 border-b border-white/5 pb-2" data-id="element-334">
          Evidencia y Micro-acción
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4" data-id="element-335">
          <div data-id="element-336">
            <label className="block text-[12px] font-medium text-growthly-muted mb-1" data-id="element-337">
              Tipo
            </label>
            <select value={lead.MICRO_ACCION_TYPE || ''} onChange={e => onChange('MICRO_ACCION_TYPE', e.target.value)} className="input-field" data-id="element-338">
              <option value="" data-id="element-339">Seleccionar...</option>
              <option value="Demo" data-id="element-340">Demo</option>
              <option value="Propuesta" data-id="element-341">Propuesta</option>
              <option value="Cita" data-id="element-342">Cita</option>
              <option value="Otro" data-id="element-343">Otro</option>
            </select>
          </div>
          <div data-id="element-344">
            <label className="block text-[12px] font-medium text-growthly-muted mb-1" data-id="element-345">
              Fecha
            </label>
            <input type="datetime-local" value={lead.MICRO_ACCION_DATE ? lead.MICRO_ACCION_DATE.substring(0, 16) : ''} onChange={e => onChange('MICRO_ACCION_DATE', e.target.value)} className="input-field" data-id="element-346" />
          </div>
          <div data-id="element-347">
            <label className="block text-[12px] font-medium text-growthly-muted mb-1" data-id="element-348">
              Canal
            </label>
            <select value={lead.CANAL_CONFIRMACION || ''} onChange={e => onChange('CANAL_CONFIRMACION', e.target.value)} className="input-field" data-id="element-349">
              <option value="" data-id="element-350">Seleccionar...</option>
              <option value="WhatsApp" data-id="element-351">WhatsApp</option>
              <option value="Email" data-id="element-352">Email</option>
              <option value="Teléfono" data-id="element-353">Teléfono</option>
              <option value="DM" data-id="element-354">DM</option>
            </select>
          </div>
        </div>

        <div className="mb-4" data-id="element-355">
          <label className="block text-[12px] font-medium text-growthly-muted mb-1" data-id="element-356">
            Texto Evidencia (Copia exacta)
          </label>
          <textarea value={lead.TEXTO_EVIDENCIA || ''} onChange={e => onChange('TEXTO_EVIDENCIA', e.target.value)} rows={3} placeholder="Pega aquí la respuesta exacta del decisor..." className="input-field resize-none" data-id="element-357" />
        </div>

        <div data-id="element-358">
          <label className="block text-[12px] font-medium text-growthly-muted mb-2" data-id="element-359">
            Adjuntos (Capturas, audios)
          </label>
          <div className="border-2 border-dashed border-white/10 rounded-lg p-4 text-center hover:bg-white/5 transition-colors cursor-pointer bg-growthly-bg" data-id="element-360">
            <UploadCloud className="w-6 h-6 text-growthly-muted mx-auto mb-2" data-id="element-361" />
            <p className="text-[13px] text-growthly-text font-medium" data-id="element-362">
              Click para subir o arrastra archivos
            </p>
            <p className="text-[11px] text-growthly-muted mt-1" data-id="element-363">
              Soporta imágenes, PDF, MP3 (Max 10MB)
            </p>
          </div>

          {lead.EVIDENCE_ATTACHMENTS && lead.EVIDENCE_ATTACHMENTS.length > 0 && <div className="mt-3 space-y-2" data-id="element-364">
                {lead.EVIDENCE_ATTACHMENTS.map(att => <div key={att.id} className="flex items-center justify-between p-2 border border-white/5 rounded bg-white/5" data-id="element-365">
                    <div className="flex items-center" data-id="element-366">
                      <FileText className="w-4 h-4 text-growthly-muted mr-2" data-id="element-367" />
                      <span className="text-[12px] font-medium text-growthly-text" data-id="element-368">
                        {att.filename}
                      </span>
                    </div>
                    <button className="text-[12px] text-growthly-red hover:underline" data-id="element-369">
                      Eliminar
                    </button>
                  </div>)}
              </div>}
        </div>
      </div>
    </div>;
}